export const SUPPORT_INIT_CATEGORIES = "support/initialise-categories";
export const SUPPORT_INIT_LANDING_FAQS = "support/initialise-landing-faqs";
